import { render } from "./TechnologyArticleList.vue?vue&type=template&id=9660bc5c"
import script from "./TechnologyArticleList.vue?vue&type=script&lang=js"
export * from "./TechnologyArticleList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__